import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { ServiceData } from '@/Shared/AutoGenerated/Main'

export default class GroupSchedulingSettings {
    constructor(
        public readonly isMultiSeatAllowed: boolean,
        public readonly maximumNumberOfSeatsPerAttendee: number,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: ServiceData['groupSchedulingSettings'],
    ): GroupSchedulingSettings {
        return new GroupSchedulingSettings(
            entityData.isMultiSeatAllowed,
            entityData.maximumNumberOfSeatsPerAttendee,
        )
    }
}
